import createState from '@wheelbox/lithejs-state';
import {
  APP_GLOBAL_SLICE,
  APP_MODAL_SLICE,
  APP_THEME_STORAGE_KEY,
  APP_TUTORIAL_SLICE,
  APP_DOCS_SLICE,
  APP_UI_SLICE,
  APP_DEMO_SLICE,
  APP_NEWSLETTER_SLICE,
} from '../constants/app';
import {
  GlobalSlice,
  ModalSlice,
  ThemeType,
  TutorialPageSlice,
  DocsPageSlice,
  UISlice,
  DemoSlice,
  NewsletterSlice,
} from './index.model';

const state = createState();

state.createSlice<ModalSlice>(APP_MODAL_SLICE, {});
state.createSlice<GlobalSlice>(APP_GLOBAL_SLICE, {
  theme: (localStorage.getItem(APP_THEME_STORAGE_KEY) as ThemeType) ?? 'light',
});
state.createSlice<TutorialPageSlice>(APP_TUTORIAL_SLICE, { sections: [] });
state.createSlice<DocsPageSlice>(APP_DOCS_SLICE, { sections: [] });

// New homepage slices
state.createSlice<UISlice>(APP_UI_SLICE, {
  mobileMenuOpen: false,
  activeTab: 'overview',
  scrollY: 0,
});

state.createSlice<DemoSlice>(APP_DEMO_SLICE, {
  activeExample: 0,
  isPlaying: true,
  terminalOutput: [],
});

state.createSlice<NewsletterSlice>(APP_NEWSLETTER_SLICE, {
  email: '',
  status: 'idle',
});

export const { withSlice, updateSlice, deleteSlice, subscribe, unsubscribe } =
  state;
